import React from "react";
import { branch } from 'baobab-react/higher-order';
import _ from "lodash";
import autoBind from "react-autobind";

import PlayerItemValueReadOnly from "./PlayerItemValueReadOnly";
import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
import { getDatasourceStateTreePathForRefId, retrieveDatasourceForRef } from "../../actions/datasource";
import GenericPicker from "./GenericPicker";
class PlayerPicker extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
		this.state = {};
	}

	onSubmit() {
		this.doSubmit(this.props.item.value, this.state.pickerItem);
	}

	onChangeSubmit(value, pickerItem) {
		let submittedValue = this.props.item.value;
		if (!_.isUndefined(value)) {
			submittedValue = value;
		}
		this.doSubmit(submittedValue, pickerItem);
	}

	doSubmit(value, pickerItem) {

		let item = this.props.item;
		let linkOnSelect;
		let linkActionType;
		let linkId;

		if (item.hasOwnProperty("pickerLinkOnSelect")) {
			linkOnSelect = (item.pickerLinkOnSelect) ? item.pickerLinkOnSelect : false;
		}

		if (item.hasOwnProperty("pickerLinkActionType")) {
			linkActionType = (item.pickerLinkActionType) ? item.pickerLinkActionType : "goto";
		}

		if (!_.isUndefined(pickerItem) && pickerItem.hasOwnProperty("linking")) {
			linkOnSelect = true;
			linkActionType = pickerItem.linking.split(":")[0];
			linkId = pickerItem.linking.split(":")[1];
		}

		if (this.props.onSubmit) {
			this.props.onSubmit(value, linkOnSelect, linkId, linkActionType);
		}
	}

	onClickDoneSubmit() {
		let item = this.props.item;

		if (item.pickerItemViewType === "buttons") {
			if (this.props.onSubmit) {
				//with buttons done should advance forward and not link
				this.props.onSubmit(this.props.item.value, false, "", "");
			}
		} else {
			this.onSubmit();
		}
	}

	onChange(value, pickerItem) {

		let item = this.props.item;

		this.setState({
			pickerItem: pickerItem
		});

		//for buttons we submit immediately
		if ((item.hasOwnProperty("pickerAdvanceOnSelect") && item.pickerAdvanceOnSelect) ||
			(item.hasOwnProperty("pickerLinkOnSelect") && item.pickerLinkOnSelect === true) ||
			(!_.isUndefined(pickerItem) && pickerItem.hasOwnProperty("linking"))) {
			this.onChangeSubmit(value, pickerItem);
		} else {
			if (this.props.onChange) {
				this.props.onChange(value, pickerItem);
			}
		}
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	renderReadOnly() {
		return (
			<PlayerItemValueReadOnly item={this.props.item} />
		);
	}

	renderEditable() {
		const { item, getImage, getVideo, getPdf, pickerItemsDatasourceResource, listIndex, sectionIndex, itemIndex, disabled } = this.props;

		let type;
		if (item.pickerItemViewType === "buttons") {
			type = "PlayerPickerButtons";
		} else if (item.pickerItemViewType === "dropdown-filter") {
			type = "PlayerPickerDropdownFilter";
		} else {
			type = "PlayerPickerSelect";
		}

		const pickerComponent = <GenericPicker type={type} item={item} onChange={this.onChange} pickerItemsDatasourceResource={pickerItemsDatasourceResource} disabled={disabled} />;

		let doneButton;
		if (!disabled && (!item.hasOwnProperty("pickerAdvanceOnSelect") || !item.pickerAdvanceOnSelect)) {
			doneButton = <DoneButton onSubmit={this.onClickDoneSubmit} />;
		}
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const component = <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ width: "100%", overflow: "visible" }}>
				<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
				<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
				{getImage()}
				{getVideo()}
				{getPdf()}
				<div style={{ marginBottom: "16px" }}>
					{pickerComponent}
				</div>
				{doneButton}
			</div>
		</div>;
		return component;
	}

	componentDidMount() {
		const { item } = this.props;
		console.log("Did mount", item);
		if (item && item.pickerItemsDatasource && !_.isEmpty(item.pickerItemsDatasource)) {
			console.log("Going to retrieve and inject datasource");
			retrieveDatasourceForRef(item.pickerItemsDatasource);
		}
	}
}

export default branch((props) => {
	const branches = {}
	// self.props.listIndex, self.props.sectionIndex, self.props.itemIndex
	if (props.item && props.item.pickerItemsDatasource && !_.isEmpty(props.item.pickerItemsDatasource) && props.hasOwnProperty("listIndex") && props.hasOwnProperty("sectionIndex") && props.hasOwnProperty("itemIndex")) {
		// tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
		const path = getDatasourceStateTreePathForRefId(props.item.pickerItemsDatasource.refId);
		console.log("Hooking up data source for branch", props.item.pickerItemsDatasource, path);
		if (path) {
			branches.pickerItemsDatasourceResource = path;
		}
	}

	return branches;
}, withPlayerItemHoc(PlayerPicker));